export const COURSE = {
  code: "MODULE 01",
  title: "ChatGPT Mastery",
  subtitle: "12 leçons complètes · certification AIBA",
  totalMinutes: 285,
  lessons: [
    { n: 1, title: "Introduction à ChatGPT", duration: "10 min",
      points: ["Qu'est-ce que ChatGPT ?", "Comment fonctionne un LLM", "GPT vs Google", "Les erreurs fréquentes"],
      task: "Exercice : créer son premier prompt." },
    { n: 2, title: "Les Fondations du Prompt Engineering", duration: "15 min",
      points: ["Pourquoi certains prompts donnent de mauvais résultats", "Structure d'un prompt parfait", "Contexte + rôle + objectif"],
      task: "Exercice : transformer un mauvais prompt en excellent prompt." },
    { n: 3, title: "La Méthode R.O.L.E", duration: "20 min",
      points: ["R = Rôle", "O = Objectif", "L = Limites", "E = Exemple"],
      task: "Prompt modèle : « Tu es un expert marketing Facebook. Crée une campagne pour vendre une formation IA à des entrepreneurs africains. »" },
    { n: 4, title: "Les 20 Prompts les Plus Rentables", duration: "20 min",
      points: ["Vente", "Marketing", "Réseaux sociaux", "Publicité", "Service client"],
      task: "Bonus : pack PDF de 20 prompts." },
    { n: 5, title: "Créer du Contenu Viral", duration: "25 min",
      points: ["Facebook", "TikTok", "Instagram", "Shorts YouTube"],
      task: "Projet : créer 30 jours de contenu en 10 minutes." },
    { n: 6, title: "Créer une Entreprise avec ChatGPT", duration: "25 min",
      points: ["Trouver une idée", "Nom de marque", "Logo", "Plan d'affaires"],
      task: "Projet : créer une entreprise complète." },
    { n: 7, title: "ChatGPT pour le Marketing Digital", duration: "30 min",
      points: ["Publicités Facebook", "Funnels", "Emails", "Landing pages"],
      task: "Projet : créer une campagne complète." },
    { n: 8, title: "Automatiser son Travail", duration: "20 min",
      points: ["Automatisation IA", "Agents IA", "Gain de temps"],
      task: "Projet : créer son premier assistant IA." },
    { n: 9, title: "Gagner de l'Argent avec ChatGPT", duration: "30 min",
      points: ["Freelance IA", "Création de contenu", "Consulting", "Formation"],
      task: "Objectif : premier 100 $." },
    { n: 10, title: "ChatGPT + Canva", duration: "20 min",
      points: ["Création de posts", "Carrousels", "Publicités"],
      task: "Projet : créer 10 visuels professionnels." },
    { n: 11, title: "ChatGPT + Business Automation", duration: "25 min",
      points: ["CRM", "Réponses automatiques", "Support client"],
      task: "Projet : automatiser une entreprise." },
    { n: 12, title: "Niveau Expert AIBA", duration: "45 min",
      points: ["Création d'un système complet IA", "Monétisation", "Scaling"],
      task: "Projet final : créer une entreprise assistée par IA de A à Z." },
  ],
  certification: {
    title: "Certificat AIBA ChatGPT Mastery",
    conditions: ["Réussir les 12 quiz", "Réaliser le projet final", "Obtenir 80 % ou plus"],
  },
};
